import type { SpaceDashboardRow } from "../mock/mockData";

interface AdminSpacesTableProps {
  readonly rows: readonly SpaceDashboardRow[];
}

export function AdminSpacesTable({ rows }: AdminSpacesTableProps) {
  return (
    <section className="admin-panel admin-table-panel">
      <div className="admin-panel-heading">
        <div>
          <h2>Spaces you manage</h2>
          <p>Mock/API data scaffold for owned and admin-managed Spaces.</p>
        </div>
      </div>
      <table className="admin-table spaces-dashboard-table">
        <thead>
          <tr>
            <th scope="col">Space</th>
            <th scope="col">Plan</th>
            <th scope="col">Members</th>
            <th scope="col">Rooms</th>
            <th scope="col">Retention</th>
            <th scope="col">Role</th>
            <th scope="col">Relay</th>
            <th scope="col">Mode</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.spaceId}>
              <td>
                <a href={`/admin/spaces/${encodeURIComponent(row.spaceId)}`}>
                  {row.name}
                </a>
              </td>
              <td>{row.planState}</td>
              <td>
                {row.memberCount}/{row.memberCap}
              </td>
              <td>
                {row.roomCount}/{row.roomCap}
              </td>
              <td>{row.retentionLabel}</td>
              <td>{row.role}</td>
              <td>{row.relayStatus}</td>
              <td>
                {row.freeLimitMode ? (
                  <span className="status-chip warning">Free Limit Mode</span>
                ) : (
                  <span className="status-chip success">Normal</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
